import { render, staticRenderFns } from "./VideoToolBar.vue?vue&type=template&id=52b6fe4a&scoped=true&"
import script from "./VideoToolBar.vue?vue&type=script&lang=ts&"
export * from "./VideoToolBar.vue?vue&type=script&lang=ts&"
import style0 from "./VideoToolBar.vue?vue&type=style&index=0&id=52b6fe4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b6fe4a",
  null
  
)

export default component.exports